import segment from 'src/js/modules/analytics/segment';
import settingIds from '../constants/setting-ids';
import mediaTypeIds from '../constants/media-type-ids';

const {
  constants,
  trackers: { trackEvent },
} = segment;

const trackMediaCropButtonClicked = ({ tabId, blockId, blockVariationId }) => {
  if (!blockId || !blockVariationId) return;

  trackEvent(constants.events.ELEMENT_SETTINGS_MEDIA_CROP_BUTTON_CLICKED, {
    blockId,
    blockVariationId,
    settingId: settingIds.THIS_MEDIA,
    tabId,
    elementId: mediaTypeIds.IMAGE,
  });
};

export default trackMediaCropButtonClicked;
